import { createRouter, createWebHistory } from 'vue-router'

import userRoutes from './userRoutes';
import adminRoutes from "./adminRoutes";
import guestRoutes from "./guestRoutes";
import { ROLES } from "../helpers/config";

const routes = [
    ...userRoutes,
    ...guestRoutes,
    ...adminRoutes
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next)=> {
  document.title = to.meta.title || 'GOFAR';
  if(to.matched.some(record => record.meta.role === ROLES.AUTHENTICATED)) {
    if(!localStorage.getItem('access_token')){
      localStorage.setItem('redirectTo', to.fullPath);
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.role === ROLES.ADMIN)) {
    if (localStorage.getItem('access_token') && localStorage.getItem('role') === ROLES.ADMIN) {
      next();
    } else {
      next({
        path: '/login',
        params: {nextUrl: to.fullPath}
      })
    }
  } else {
    next();
  }
});

export default router
